/**
 * @generated SignedSource<<d34bb8183fbdb40efcc6007b196c5fa5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchResultListArticleSearchQuery$data = {
  readonly articleSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ArticleSearchResultItem";
      };
    }>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"articleSearchResultListQuery">;
  readonly " $fragmentType": "searchResultListArticleSearchQuery";
};
export type searchResultListArticleSearchQuery$key = {
  readonly " $data"?: searchResultListArticleSearchQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultListArticleSearchQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "orderBy"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "searchResultListArticleSearchQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "ArticleSearchConnection",
      "kind": "LinkedField",
      "name": "articleSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleSearchResultItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSearchResultListQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "408c1391e77fe0ac24fb7cc6f085383e";

export default node;
